import React from 'react'
import './Hero.css'
import{Link} from 'react-scroll'

const Hero = () => {
    return (
        <div className='hero' id='hero'>
            <div className='content'>
                <p>House is a term</p>
                <p>Home is an Emotion</p>
                
                
                <Link to='demo' spy={true} smooth={true} offset={-100} duration={500}  ><button  className='button'>book a call</button></Link>
            </div>
        </div>
    )
}

export default Hero
